import Config from '../config';

const getS3AssetUrl = (assetPath: string): string => {
  return `${Config.ASSET_URL}/${assetPath}`;
}

export default getS3AssetUrl;
